import { render, staticRenderFns } from "./PendingOrdersRoute.vue?vue&type=template&id=6d9c6508&"
import script from "./PendingOrdersRoute.vue?vue&type=script&lang=ts&"
export * from "./PendingOrdersRoute.vue?vue&type=script&lang=ts&"
import style0 from "./PendingOrdersRoute.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports